import { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import { useIntl } from 'react-intl';

import { ContextWrapper } from 'contexts/wrapper.context';
import { getTeamMembersAccess } from 'utils/permissions/permissions-apply';

import Header from 'components/Header/Header';
import Container from 'components/Container/Container';
import LoadingWrapper from 'components/LoadingWrapper/LoadingWrapper';
import TeamMembersTable from 'components/NewTeamMembers/components/TeamMembersTable/TeamMembersTable';
import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as PlusIcon } from 'assets/bosta-icons/Plus.svg';

import './TeamMembers.less';

const TeamMembers = () => {
  const { formatMessage } = useIntl();
  const history = useHistory();
  const { businessInfo } = useContext(ContextWrapper);

  const [isLoading, setIsLoading] = useState(false);

  const handleNewMember = () => {
    history.push('team-members/create');
  };

  const { HIDE_CREATE_MEMBER } = getTeamMembersAccess(
    businessInfo?.userSllrPermissions
  );

  return (
    <Container
      header={
        <Header
          title={formatMessage({ id: 'team_members.header.title' })}
          subTitle={formatMessage({ id: 'team_members.header.subtitle' })}
        />
      }
      content={
        <LoadingWrapper loading={isLoading}>
          <div className="br-team-members__content">
            <div className="br-team-members__subheader">
              {!HIDE_CREATE_MEMBER && (
                <BRButton
                  type="primary"
                  label={formatMessage({
                    id: 'team_members.actions.new_member'
                  })}
                  prefixIcon={<PlusIcon />}
                  onClick={handleNewMember}
                />
              )}
            </div>
            <TeamMembersTable
              setIsLoading={setIsLoading}
              permissions={getTeamMembersAccess(
                businessInfo?.userSllrPermissions
              )}
            />
          </div>
        </LoadingWrapper>
      }
    />
  );
};

export default TeamMembers;
